import constants from "./CONSTANTS";

const actions = {
  setLanguage: (lang) => ({
    type: constants.SET_LANGUAGE,
    lang,
  }),
  setSidebarOpen: (status) => ({
    type: constants.SET_SIDEBAR_OPEN,
    status,
  }),
  toggleSidebarOpen: () => ({
    type: constants.TOGGLE_SIDEBAR_OPEN,
  }),
  resetCommon: () => ({
    type: constants.RESET_COMMON,
  }),
  setAPICallExecuted: () => ({
    type: constants.SET_API_CALL_EXECUTED,
  }),
  addAdditionalTranslations: (payload) => ({
    type: constants.ADD_ADDITIONAL_TRANSLATIONS,
    payload,
  }),
  moduleLoaded: (payload) => ({
    type: constants.MODULE_LOADED,
    payload,
  }),

  // user agreement
  getUserAgreement: (payload) => ({
    type: constants.GET_USER_AGREEMENT,
    payload,
  }),
  getUserAgreementById: () => ({
    type: constants.GET_USER_AGREEMENT_BY_ID,
  }),
  setUserAgreement: (payload) => ({
    type: constants.SET_USER_AGREEMENT,
    payload,
  }),
  setUserAgreementById: (payload) => ({
    type: constants.SET_USER_AGREEMENT_BY_ID,
    payload,
  }),
  setContractsModalIsOpen: (payload) => ({
    type: constants.SET_CONTRACTS_MODAL_IS_OPEN,
    payload,
  }),
  setSelectedAgreement: (payload) => ({
    type: constants.SET_SELECTED_AGREEMENT,
    payload,
  }),

  getNotifications: (calledFromHub) => ({
    type: constants.GET_NOTIFICATIONS,
    payload: calledFromHub,
  }),
  setNotifications: (payload) => ({
    type: constants.SET_NOTIFICATIONS,
    payload,
  }),
  readNotification: (notificationId, callbackActions = []) => ({
    type: constants.READ_NOTIFICATION,
    payload: { notificationId, callbackActions },
  }),
  setNotificationsOpen: (isOpen) => ({
    type: constants.SET_NOTIFICATIONS_OPEN,
    payload: isOpen,
  }),
  getAllNotifications: (calledFromHub) => ({
    type: constants.GET_ALL_NOTIFICATIONS,
    payload: calledFromHub,
  }),
  setAllNotifications: (payload) => ({
    type: constants.SET_ALL_NOTIFICATIONS,
    payload,
  }),
  setAllNotificationsOpen: (isOpen) => ({
    type: constants.SET_ALL_NOTIFICATIONS_OPEN,
    payload: isOpen,
  }),
  receiveNotifications: () => ({
    type: constants.RECEIVE_NOTIFICATIONS,
  }),
  setWebsocketConnected: (isConnected) => ({
    type: constants.SET_WEBSOCKET_CONNECTED,
    payload: isConnected,
  }),
  getDownloadDocument: (payload) => ({
    type: constants.GET_DOWNLOAD_DOCUMENT,
    payload,
  }),
  setDownloadDocumentLoading: (payload) => ({
    type: constants.SET_DOWNLOAD_DOCUMENT_LOADING,
    payload,
  }),
  getDocTitles: (payload) => ({
    type: constants.GET_LEGAL_INFO_DOC_TITLES,
    payload,
  }),
  setDocTitles: (payload) => ({
    type: constants.SET_LEGAL_INFO_DOC_TITLES,
    payload,
  }),
};

export default actions;
